module.exports = __webpack_public_path__ + "static/teacher-aada42a4d466ac7cc6f5f85f27956b03.svg";